/** Shared usage-duration values for sell forms + catalog filters. */

export const USAGE_DURATION_ORDER = [
  '1_3m',
  '3_6m',
  '6_12m',
  '1_2y',
  '2y_plus',
  'unknown',
] as const

export type UsageDurationKey = (typeof USAGE_DURATION_ORDER)[number]

export function isUsageDurationKey(v: string | null | undefined): v is UsageDurationKey {
  return !!v && (USAGE_DURATION_ORDER as readonly string[]).includes(v)
}
